import { SpriteSheet, Sprite } from '@createjs/easeljs';

class Bullet {
  constructor(x, y, engine) {
    this.x = x + 28;
    this.y = y;
    this.engine = engine;
    this.name = 'bullet';
    this.spriteSheet = new SpriteSheet({
      images: [this.engine.assets.ammoImg],
      frames: {
        width: 8,
        height: 21,
      },
      animations: {
        run: {
          frames: [0, 1, 2, 3, 2, 1],
          next: false,
          frequency: 2,
        },
      },
    });
  }

  draw() {
    const animation = new Sprite(this.spriteSheet);
    animation.x = this.x;
    animation.y = this.y;
    animation.gotoAndStop('run');
    this.graphics = animation;
    this.engine.containers.game.addChild(animation);
    this.engine.stage.update();
  }

  update(_i) {
    this.graphics.y -= 25;
    if (this.graphics.y < -25) {
      this.engine.containers.game.removeChild(this.graphics);
      this.engine.bullets.splice(_i, 1);
    }
  }

  kill(_i) {
    this.engine.containers.game.removeChild(this.graphics);
    this.engine.bullets.splice(_i, 1);
  }
}

export default Bullet;
